import React, { useState } from 'react';
import { auth } from '@/api';
import { LogIn, Loader2, AlertCircle, MailCheck } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Bascule la carte en mode « demande de lien » plutôt que d'ouvrir une
  // seconde page : le mot de passe oublié se règle sans quitter l'écran.
  const [modeOubli, setModeOubli] = useState(false);
  const [lienEnvoye, setLienEnvoye] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await auth.signIn(email.trim(), password);
      window.location.assign('/');
    } catch (err) {
      setError(err.message || 'Connexion impossible');
      setLoading(false);
    }
  };

  const demanderLien = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await auth.requestPasswordReset(email.trim());
      setLienEnvoye(true);
    } catch (err) {
      setError(err.message || 'Envoi impossible');
    } finally {
      setLoading(false);
    }
  };

  const basculerOubli = (actif) => {
    setModeOubli(actif);
    setError(null);
    setLienEnvoye(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4 safe-area-pt safe-area-pb">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4"
            style={{
              background: 'hsl(var(--primary))',

            }}>
            <span className="text-white font-bold text-lg" style={{ letterSpacing: '-0.03em' }}>WF</span>
          </div>
          <h1 className="text-2xl font-semibold text-foreground tracking-tight">CRM Webforce Group</h1>
          <p className="text-sm text-muted-foreground mt-1">
            {modeOubli
              ? 'Recevez un lien pour choisir un nouveau mot de passe'
              : 'Connectez-vous à votre dashboard'}
          </p>
        </div>

        <form onSubmit={modeOubli ? demanderLien : submit} className="kpi-card-modern space-y-4 p-6">
          <div className="space-y-2">
            <label htmlFor="email" className="text-sm font-medium text-foreground">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="vous@webforce.be"
              className="w-full h-11 px-3 rounded-xl bg-secondary/50 border border-border text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
              disabled={loading}
            />
          </div>

          {!modeOubli && (
            <div className="space-y-2">
              <label htmlFor="password" className="text-sm font-medium text-foreground">Mot de passe</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full h-11 px-3 rounded-xl bg-secondary/50 border border-border text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                disabled={loading}
              />
            </div>
          )}

          {error && (
            <div className="flex items-start gap-2 p-3 rounded-xl bg-rose/10 border border-rose/20 text-sm text-rose">
              <AlertCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
              <span>{error}</span>
            </div>
          )}

          {lienEnvoye && (
            <div className="flex items-start gap-2 p-3 rounded-xl bg-emerald/10 border border-emerald/20 text-sm text-emerald">
              <MailCheck className="w-4 h-4 flex-shrink-0 mt-0.5" />
              <span>
                Si un compte existe pour cette adresse, un lien vient d'être envoyé.
                Il est valable une heure.
              </span>
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !email || (!modeOubli && !password) || lienEnvoye}
            className="w-full h-11 rounded-xl bg-primary text-primary-foreground font-medium text-sm flex items-center justify-center gap-2 hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                {modeOubli ? 'Envoi…' : 'Connexion…'}
              </>
            ) : modeOubli ? (
              <>
                <MailCheck className="w-4 h-4" />
                Envoyer le lien
              </>
            ) : (
              <>
                <LogIn className="w-4 h-4" />
                Se connecter
              </>
            )}
          </button>

          <button
            type="button"
            onClick={() => basculerOubli(!modeOubli)}
            className="w-full text-center text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            {modeOubli ? 'Retour à la connexion' : 'Mot de passe oublié ?'}
          </button>
        </form>

        <p className="text-center text-xs text-muted-foreground mt-6">
          © Webforce Benelux · CRM Webforce Group
        </p>
      </div>
    </div>
  );
}
